<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JSCtfj/tc-custom/9780830892648.jpg?1696870364561" alt="This image is the cover for the book Old Earth or Evolutionary Creation?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Old Earth or Evolutionary Creation?
      </h1>
      <p class="bookDescription body article font2">
        <em>how</em><em>Old Earth or Evolutionary Creation?</em>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kenneth Keathley
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e49e1ed6